export default __webpack_public_path__ + "static/media/lilyar.30c9cfad.png";